import type { UserSessionContext } from '@/store/slices/session/types';

const nonEmptyJwtOrId = (v: string | null | undefined) =>
  typeof v === 'string' && v.trim().length > 0;

/**
 * Whether the user session is safe to treat as “ready for game load” (leave initializing placeholder,
 * send handshake). After logout / {@link subscribeSession} with `undefined`, the store may briefly
 * or incorrectly signal activity unless all tokens are present.
 *
 * Web/desktop: requires `hasActiveSession` plus auth JWT, login JWT, and session id (matches
 * cookie/session validation in {@link getLocalAccountSession}).
 *
 * Android / Xsell: UM may not populate the same cookie-backed fields; rely on `hasActiveSession` only.
 */
export const areUserSessionTokensReadyForGame = (
  ctx: UserSessionContext,
  bypassStrictTokenChecks?: boolean,
): boolean => {
  if (!ctx.hasActiveSession) {
    return false;
  }
  if (bypassStrictTokenChecks) {
    return true;
  }
  return (
    nonEmptyJwtOrId(ctx.authToken?.jwt) &&
    nonEmptyJwtOrId(ctx.loginToken?.jwt) &&
    nonEmptyJwtOrId(ctx.sessionId)
  );
};
